export const authServiceRun = ['Restangular', (Restangular: Restangular.IService) => {
    
}]


// WEBPACK FOOTER //
// ./src/app/authsettings/authsettings.run.ts